import React from 'react';

import Modal from 'components/curo-components/common/Modal';
import Button from 'components/digifi-wrappers/Button';
import { DocumentIcon } from 'static/images';

interface IExistingApplicationModal {
  onClose: () => void;
  onButtonClick: () => void;
}

const ExistingApplicationModal = ({ onButtonClick, onClose }: IExistingApplicationModal) => {
  return (
    <Modal
      actionElement={
        <Button size="form" kind="primary" onClick={onButtonClick}>
          Click here to see your offer
        </Button>
      }
      description="Great news! You already have an existing application."
      title="Welcome Back!"
      modalIcon={<DocumentIcon />}
      onClose={onClose}
    />
  );
};

export default ExistingApplicationModal;
